<div class="project-schedule-step">
  <div *ngIf="!loading && ganttTasks.length > 0" class="schedule-content">
    <!-- Minified Gantt Chart -->
    <div class="minified-gantt-container">
      <dx-gantt
        #minifiedGantt
        class="gpd-gantt"
        scaleType="months"
        taskTitlePosition="none"
        height="100%"
        width="100%"
        [firstDayOfWeek]="0"
        (onTaskEditDialogShowing)="$event.cancel = true"
        (onTaskUpdating)="onTaskUpdating($event)"
        (onTaskUpdated)="onTaskUpdated($event)"
        (onTaskInserted)="onTaskInserted($event)"
        (onTaskDeleted)="onTaskDeleted($event)"
        (onDependencyInserted)="onDependencyInserted($event)"
        (onDependencyDeleted)="onDependencyDeleted($event)"
        (onContextMenuPreparing)="onContextMenuPreparing($event)"
        taskTooltipContentTemplate="taskTooltipContentTemplate"
        taskTimeTooltipContentTemplate="taskTimeTooltipContentTemplate"
        (onDependencyInserting)="onDependencyInserting($event)"
      >
        <dxo-gantt-context-menu [enabled]="true"></dxo-gantt-context-menu>
        <dxi-strip-line [start]="currentdate" title="Now" cssClass="current-time"> </dxi-strip-line>
        <dxo-toolbar>
          <dxi-item name="zoomIn" menuItemTemplate="itemTemplate">
            <div *dxTemplate="let data of 'itemTemplate'">
              <app-gpd-button
                icon="search-add"
                type="text"
                (onClick)="data.item.onClick()"
                color="var(--color-primary)"
              ></app-gpd-button>
            </div>
          </dxi-item>
          <dxi-item name="zoomOut" menuItemTemplate="itemTemplate">
            <div *dxTemplate="let data of 'itemTemplate'">
              <app-gpd-button
                icon="search-minus"
                type="text"
                (onClick)="data.item.onClick()"
                color="var(--color-primary)"
              ></app-gpd-button>
            </div>
          </dxi-item>
          <dxi-item name="safeMode" *ngIf="isAdmin">
            <div *dxTemplate class="safe-mode-container">
              <dx-check-box
                class="gpd-input"
                i18n-text="@@safeMode"
                text="Safe Mode"
                [(value)]="safeMode"
                (onValueChanged)="onSafeModeChanged($event)"
              ></dx-check-box>
              <app-svg-icon icon="help" color="var(--color-grey-900)" class="help-icon-minified" [size]="16"></app-svg-icon>
              <dx-popover
                target=".help-icon-minified"
                showEvent="mouseenter"
                hideEvent="mouseleave"
                [wrapperAttr]="{ class: 'gpd-popover' }"
                position="bottom"
                style="display: none"
              >
                <div class="help-context" i18n="@@safeModeHelp">
                  When enabled, the plan automatically ensures a logical chronological order of connected elements and
                  prevents circular dependencies. If the option is disabled, all elements can be moved freely.
                </div>
              </dx-popover>
            </div>
          </dxi-item>
          <dxi-item name="expand" menuItemTemplate="itemTemplate" location="after">
            <div *dxTemplate="let data of 'itemTemplate'">
              <app-gpd-button
                icon="arrow-expand"
                type="text"
                (onClick)="expandedPopupVisible = true"
                color="var(--color-primary)"
              ></app-gpd-button>
            </div>
          </dxi-item>
        </dxo-toolbar>
        <dxo-gantt-scale-type-range max="months" min="days"></dxo-gantt-scale-type-range>
        <dxo-editing
          [enabled]="true"
          [allowDependencyDeleting]="true"
          [allowTaskAdding]="false"
          [allowTaskDeleting]="false"
        >
        </dxo-editing>
        <dxo-validation
          [autoUpdateParentTasks]="true"
          [validateDependencies]="safeMode"
          [enablePredecessorGap]="true"
        ></dxo-validation>
        <dxo-tasks
          [dataSource]="ganttTasks"
          keyExpr="id"
          parentIdExpr="parentId"
          endExpr="endDate"
          startExpr="startDate"
          titleExpr="title"
          colorExpr="color"
        ></dxo-tasks>
        <dxo-dependencies
          [dataSource]="ganttDependancies"
          keyExpr="id"
          successorIdExpr="taskId"
          typeExpr="dependencyType"
          predecessorIdExpr="dependancyOnId"
        ></dxo-dependencies>
         <dxi-column dataField="sortingIndex" [visible]="false" [sortIndex]="0" sortOrder="asc"></dxi-column>
        <dxi-column dataField="title" caption="Task" [width]="200"></dxi-column>

        <div *dxTemplate="let data of 'taskTooltipContentTemplate'">
          <div class="tooltip-content">
            <div class="tooltip-title">{{ data.title }}</div>
            <div class="tooltip-row">
              <span class="row-title" i18n="@@start">Start</span>
              <span class="row-value">
                {{ data.startDate | date: 'dd.MM.yyyy' }}
              </span>
            </div>
            <div class="tooltip-row">
              <span class="row-title" i18n="@@end">End</span>
              <span class="row-value">
                {{ data.endDate | date: 'dd.MM.yyyy' }}
              </span>
            </div>

            <div class="tooltip-row">
              <span class="row-title" i18n="@@duration">Duration</span>
              <span class="row-value"
                >{{ getDuration(data.startDate, data.endDate) }} <span i18n="@@days">days</span></span
              >
            </div>
          </div>
        </div>

        <div *dxTemplate="let data of 'taskTimeTooltipContentTemplate'">
          <div class="tooltip-content">
            <div class="tooltip-row">
              <span class="row-title" i18n="@@start">Start</span>
              <span class="row-value">{{ data.start | date: 'dd.MM.yyyy' }} </span>
            </div>
            <div class="tooltip-row">
              <span class="row-title" i18n="@@end">End</span>
              <span class="row-value">
                {{ data.end | date: 'dd.MM.yyyy' }}
              </span>
            </div>

            <div class="tooltip-row">
              <span class="row-title" i18n="@@duration">Duration</span>
              <span class="row-value">{{ getDuration(data.start, data.end) }} <span i18n="@@days">days</span></span>
            </div>
          </div>
        </div>
      </dx-gantt>
    </div>
  </div>
  <!-- Expanded Gantt Popup -->
  <dx-popup
    [(visible)]="expandedPopupVisible"
    [showTitle]="false"
    [wrapperAttr]="{ class: 'gpd-popup' }"
    (onHiding)="hideExpandedGantt()"
    contentTemplate="ganttTemplate"
    (onShown)="onPopupShown()"
    height="90vh"
    width="80vw"
  >
    <div *dxTemplate="let data of 'ganttTemplate'">
      <dx-gantt
        #expandedGantt
        [visible]="false"
        class="gpd-gantt"
        scaleType="weeks"
        taskTitlePosition="none"
        height="100%"
        width="100%"
        [firstDayOfWeek]="0"
        (onTaskEditDialogShowing)="$event.cancel = true"
        (onTaskUpdating)="onTaskUpdating($event)"
        (onTaskUpdated)="onTaskUpdated($event)"
        (onTaskInserted)="onTaskInserted($event)"
        (onTaskDeleted)="onTaskDeleted($event)"
        (onDependencyInserted)="onDependencyInserted($event)"
        (onDependencyDeleted)="onDependencyDeleted($event)"
        (onContextMenuPreparing)="onContextMenuPreparing($event)"
        taskTooltipContentTemplate="taskTooltipContentTemplate"
        taskTimeTooltipContentTemplate="taskTimeTooltipContentTemplate"
        [taskListWidth]="500"
        (onDependencyInserting)="onDependencyInserting($event)"
      >
        <dxo-gantt-context-menu [enabled]="true"></dxo-gantt-context-menu>
         <dxi-strip-line [start]="currentdate" title="Now" cssClass="current-time"> </dxi-strip-line>
        <dxo-toolbar>
          <dxi-item name="zoomIn" menuItemTemplate="itemTemplate">
            <div *dxTemplate="let data of 'itemTemplate'">
              <app-gpd-button
                icon="search-add"
                type="text"
                (onClick)="data.item.onClick()"
                color="var(--color-primary)"
              ></app-gpd-button>
            </div>
          </dxi-item>
          <dxi-item name="zoomOut" menuItemTemplate="itemTemplate">
            <div *dxTemplate="let data of 'itemTemplate'">
              <app-gpd-button
                icon="search-minus"
                type="text"
                (onClick)="data.item.onClick()"
                color="var(--color-primary)"
              ></app-gpd-button>
            </div>
          </dxi-item>
          <dxi-item name="safeMode" *ngIf="isAdmin">
            <div *dxTemplate class="safe-mode-container">
              <dx-check-box
                class="gpd-input"
                i18n-text="@@safeMode"
                text="Safe Mode"
                [(value)]="safeMode"
                (onValueChanged)="onSafeModeChanged($event)"
              ></dx-check-box>
              <app-svg-icon icon="help" color="var(--color-grey-900)" class="help-icon-expanded" [size]="16"></app-svg-icon>
              <dx-popover
                target=".help-icon-expanded"
                showEvent="mouseenter"
                hideEvent="mouseleave"
                [wrapperAttr]="{ class: 'gpd-popover' }"
                position="bottom"
                style="display: none"
              >
                <div class="help-context" i18n="@@safeModeHelp">
                  When enabled, the plan automatically ensures a logical chronological order of connected elements and
                  prevents circular dependencies. If the option is disabled, all elements can be moved freely.
                </div>
              </dx-popover>
            </div>
          </dxi-item>
          <dxi-item name="shrink" menuItemTemplate="itemTemplate" location="after">
            <div *dxTemplate="let data of 'itemTemplate'">
              <app-gpd-button
                icon="arrow-shrink"
                type="text"
                (onClick)="expandedPopupVisible = false"
                color="var(--color-primary)"
              ></app-gpd-button>
            </div>
          </dxi-item>
        </dxo-toolbar>
        <dxo-gantt-scale-type-range max="months" min="days"></dxo-gantt-scale-type-range>
        <dxo-validation
          [autoUpdateParentTasks]="true"
          [validateDependencies]="safeMode"
          [enablePredecessorGap]="true"
        ></dxo-validation>
        <dxo-tasks
          [dataSource]="ganttTasks"
          keyExpr="id"
          parentIdExpr="parentId"
          endExpr="endDate"
          startExpr="startDate"
          titleExpr="title"
          colorExpr="color"
          progressExpr="progress"
        ></dxo-tasks>
        <dxo-dependencies
          [dataSource]="ganttDependancies"
          keyExpr="id"
          successorIdExpr="taskId"
          typeExpr="dependencyType"
          predecessorIdExpr="dependancyOnId"
        ></dxo-dependencies>
         <dxi-column dataField="sortingIndex" [visible]="false" [sortIndex]="0" sortOrder="asc"></dxi-column>
        <dxi-column dataField="title" i18n-caption="@@title" caption="Title" ></dxi-column>
        <dxi-column dataField="startDate" i18n-caption="@@startDate" caption="Start Date" [width]="100" [minWidth]="100"></dxi-column>
        <dxi-column dataField="endDate" i18n-caption="@@endDate" caption="End Date" [width]="100" [minWidth]="100"></dxi-column>

        <dxo-editing
          [enabled]="true"
          [allowDependencyDeleting]="true"
          [allowTaskAdding]="false"
          [allowTaskDeleting]="false"
        >
        </dxo-editing>

        <div *dxTemplate="let data of 'taskTooltipContentTemplate'">
          <div class="tooltip-content">
            <div class="tooltip-title">{{ data.title }}</div>
            <div class="tooltip-row">
              <span class="row-title" i18n="@@start">Start</span>
              <span class="row-value">
                {{ data.startDate | date: 'dd.MM.yyyy' }}
              </span>
            </div>
            <div class="tooltip-row">
              <span class="row-title" i18n="@@end">End</span>
              <span class="row-value">
                {{ data.endDate | date: 'dd.MM.yyyy' }}
              </span>
            </div>

            <div class="tooltip-row">
              <span class="row-title" i18n="@@duration">Duration</span>
              <span class="row-value"
                >{{ getDuration(data.startDate, data.endDate) }} <span i18n="@@days">days</span></span
              >
            </div>
          </div>
        </div>

        <div *dxTemplate="let data of 'taskTimeTooltipContentTemplate'">
          <div class="tooltip-content">
            <div class="tooltip-row">
              <span class="row-title" i18n="@@start">Start</span>
              <span class="row-value">{{ data.start | date: 'dd.MM.yyyy' }} | </span>
            </div>
            <div class="tooltip-row">
              <span class="row-title" i18n="@@end">End</span>
              <span class="row-value">
                {{ data.end | date: 'dd.MM.yyyy' }}
              </span>
            </div>

            <div class="tooltip-row">
              <span class="row-title" i18n="@@duration">Duration</span>
              <span class="row-value">{{ getDuration(data.start, data.end) }} <span i18n="@@days">days</span></span>
            </div>
          </div>
        </div>
      </dx-gantt>
    </div>
  </dx-popup>
</div>

<!-- Disable Dependencies Warning Popup -->
<app-generic-popup [visible]="showDisableDeps" i18n-title="@@disableDependencies" title="Disable dependencies" [allowOutsideClick]="false">
  <div class="disable-deps-content">
    <p i18n="@@disableDependenciesMessage1">
      If this option is disabled, all items in the schedule can be moved freely. Temporal dependencies are no longer
      checked automatically.
    </p>

    <div class="warning-box">
      <app-svg-icon icon="alert" color="var(--color-task)" class="warning-icon" [size]="20" />
      <div class="warning-content">
        <p i18n="@@disableDependenciesMessage2" style="font-weight: 500">
          This can lead to circular dependencies—i.e., dependencies that contradict each other and no longer allow for a
          clear sequence of events.
        </p>
        <p i18n="@@disableDependenciesMessage3">
          In such cases, the schedule can no longer be processed correctly, which can lead to severely limited
          functionality or unexpected behavior of the system.
        </p>
      </div>
    </div>

    <dx-check-box
      class="gpd-input"
      [(value)]="dontshowAgain"
      (onValueChanged)="onDontShowAgainChanged($event)"
      i18n-text="@@dontShowAgain"
      text="Don't show this message again."
    ></dx-check-box>
  </div>
  <div popup-actions class="action-container">
    <app-gpd-button
      type="secondary"
      i18n-text="@@cancel"
      text="Cancel"
      (onClick)="showDisableDeps = false; safeMode = true"
    ></app-gpd-button>
    <app-gpd-button
      type="primary"
      i18n-text="@@disable"
      text="Disable"
      (onClick)="showDisableDeps = false"
    ></app-gpd-button>
  </div>
</app-generic-popup>

<!-- Circular Dependency Error Popup -->
<app-generic-popup [visible]="showCircularDepError" i18n-title="@@notAllowed" title="Not allowed">
  <div class="circular-dep-content">
    <p i18n="@@circularDependencyError1">
      This action would create a circular dependency and is therefore not allowed.
    </p>
    <p i18n="@@circularDependencyError2">
      An element cannot be linked to
      another element if elements contained within or associated with it are already linked to the same element. Please
      adjust the existing dependencies.
    </p>
    <p i18n="@@circularDependencyError3" style="font-weight: 500;">
      Please adjust the existing dependencies.
    </p>
  </div>
  <div popup-actions class="action-container">
    <app-gpd-button type="primary" i18n-text="@@ok" text="OK" (onClick)="showCircularDepError = false"></app-gpd-button>
  </div>
</app-generic-popup>
